export default __webpack_public_path__ + "static/media/Reader's Gloves of the Eternal Eclipse.b7a1661e.jpg";